import { COMPLEMENT_OPERATOR_MAP } from '@/components/Dashboard/common/Filter/const';
import { FILTER_KEYS } from '@/utils/consts';

function makeDefaultItemCondition() {
    return {};
}

export function isGroup(cond) {
    if (!cond.operator) return false;
    return cond.operator === 'AND' || cond.operator === 'OR';
}

export function getConditions(condition) {
    return R.propOr([makeDefaultItemCondition()], 'conditions', condition);
}

export function getOperator(condition) {
    return R.propOr('AND', 'operator', condition);
}

export const getRefinedField = (condition) => {
    const { dataSourceType, type, field } = condition;

    return dataSourceType || type || field;
};
export function getRefinedLevel(condition) {
    const { field, level } = condition;
    const refinedField = getRefinedField(condition);

    switch (refinedField) {
        case FILTER_KEYS.GENERIC:
            return field;
        default:
            return level;
    }
}
export const getRefinedOperator = (condition) => {
    const { not, operator } = condition;

    return not ? COMPLEMENT_OPERATOR_MAP[operator] : operator;
};
export const getRefinedValues = (condition) => {
    return R.propOr([], 'values', condition);
};
